import { render, staticRenderFns } from "./DriverAddContract.vue?vue&type=template&id=6c2ed28b&scoped=true&"
import script from "./DriverAddContract.vue?vue&type=script&lang=js&"
export * from "./DriverAddContract.vue?vue&type=script&lang=js&"
import style0 from "./DriverAddContract.vue?vue&type=style&index=0&id=6c2ed28b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2ed28b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2ed28b')) {
      api.createRecord('6c2ed28b', component.options)
    } else {
      api.reload('6c2ed28b', component.options)
    }
    module.hot.accept("./DriverAddContract.vue?vue&type=template&id=6c2ed28b&scoped=true&", function () {
      api.rerender('6c2ed28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/DriverAddContract.vue"
export default component.exports